import React from 'react';

import { styled, Typography } from '@mui/material';
import PropTypes from 'prop-types';

const Div_Wrapper = styled('div')(({ theme }) => ({
  display: 'flex',
  borderRadius: theme.spacing(2),
  padding: theme.spacing(2),
  alignItems: 'center',
  boxShadow: '0px 2px 8px rgba(23, 33, 52, 0.15)',
  marginTop: theme.spacing(4),
  '& .highlight-banner-texts-wrapper': {
    padding: theme.spacing(2),
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1),
  },
}));

const HighlightBanner = ({ onTitle, title, image }) => (
  <Div_Wrapper>
    {image}
    <div className="highlight-banner-texts-wrapper">
      <Typography variant="subtitleLightBold" component="p" textAlign="left">
        {onTitle}
      </Typography>
      <Typography variant="subtitle" component="p" textAlign="left">
        {title}
      </Typography>
    </div>
  </Div_Wrapper>
);

HighlightBanner.propTypes = {
  onTitle: PropTypes.string,
  title: PropTypes.string,
  image: PropTypes.object,
};

export default HighlightBanner;
